export default "/static/media/icon-skywalker-white.b01bf2f1.svg";